/* unplugin-vue-components disabled */import { render } from "./NavAside.vue?vue&type=template&id=34740434&scoped=true&ts=true"
import script from "./NavAside.vue?vue&type=script&lang=ts"
export * from "./NavAside.vue?vue&type=script&lang=ts"

import "./NavAside.vue?vue&type=style&index=0&id=34740434&scoped=true&lang=css"
import "./NavAside.vue?vue&type=style&index=1&id=34740434&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34740434"],['__file',"src/components/nav-aside/NavAside.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34740434"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34740434', __exports__)) {
    console.log('reload')
    api.reload('34740434', __exports__)
  }
  
  module.hot.accept("./NavAside.vue?vue&type=template&id=34740434&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('34740434', render)
  })

}


export default __exports__